import urlregexp from 'urlregexp';

import {
    ILLEGAL_URL_SCHEME_REGEX,
    FAILURE_TYPES,
    FAILURE_NAMES,
    HOST_REGEX,
    LOCALHOST_REGEX,
    EMAIL_REGEX,
} from '../../validationConstants';
import { ERROR_LOCALE_KEYS } from '../../../error/errorLocaleKeys';

const URL_ERROR_OBJECT = {
    name: FAILURE_NAMES.url,
    type: FAILURE_TYPES.ERROR,
    debounced: true,
    message: 'Not a valid url',
    errorLocaleKey: ERROR_LOCALE_KEYS.VALIDATION.URL,
};

/**
 * Ensures the URL regular expression matched the entire input rather than a valid prefix.
 */
const hasCompleteUrlMatch = (fieldValue) => {
    if (/\s/.test(fieldValue)) return false;

    const matches = fieldValue.match(urlregexp);
    return matches?.some((match) => match === fieldValue);
};

export default (fieldValue, validationConfig = {}) => {
    if (!fieldValue) return null;

    if (fieldValue.match(ILLEGAL_URL_SCHEME_REGEX)) return URL_ERROR_OBJECT;
    if (fieldValue.match(EMAIL_REGEX)) return URL_ERROR_OBJECT;
    if (hasCompleteUrlMatch(fieldValue)) return null;
    if (validationConfig.allowIPAddress && fieldValue.match(HOST_REGEX)) return null;
    if (process.env.NODE_ENV === 'development' && fieldValue.match(LOCALHOST_REGEX)) return null;

    return URL_ERROR_OBJECT;
};
